// extracted by mini-css-extract-plugin
export default {"root":"Profile_root__54zbu","content":"Profile_content__wDPek","badge":"Profile_badge__T5qGB"};